import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-avatar",
  templateUrl: "./med-icon-avatar.component.html",
})
export class MedIconAvatarComponent extends SvgMixinComponent {}
